import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import { Timeline } from "primereact/timeline";
import { Tooltip } from "primereact/tooltip";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import PrimePanel from "../../../components/PrimePanel";
import { useEditableFlag } from "../../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../../store/messageStore";
import { queryApproveHistory } from "../../../utility/service/carbon-service";
import { checkDpSuccess } from "../../../utility/service/tool-service";
import { FormTextarea } from "../../../components/FormTextarea";
import { Controller, useForm } from "react-hook-form";
import { SelectButton } from "primereact/selectbutton";
import { AcctContext } from "../../../utility/useReduce/userNameReduce";
import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";
import { approveWork } from "../../../utility/service/carbon-service";
import { set } from "bignumber.js";

const ActivityTable = ({
  header,
  data,
  setItemObj,
  classNoInfo,
  places,
  setDelDialog,
  batchAction,
  batchApproveStatus = "D",
  dataDel,
  approverList = [],
  handleSettingApproveWorkFlow,
  approveFlag,
  isCompany,
  companySeq,
  reQuery
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isEditable = useEditableFlag("F10103"); // control edit by F10103
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗
  const { setAction } = useOutletContext();
  const [selectValue, setSelectValue] = useState([]);
  const [dataList, setDataList] = useState([]);
  // 審核流程設定
  const [rowData, setRowData] = useState("");
  const [approveFlowDialog, setApproveFlowDialog] = useState(false);
  const [approveFlowList, setApproveFlowList] = useState([]);
  // 審核歷史紀錄
  const [approveHistoryDialog, setApproveHistoryDialog] = useState(false);
  const [approveHistoryList, setApproveHistoryList] = useState([]);
  const [approveHistoryFlowList, setApproveHistoryFlowList] = useState([]);
  const [reApplyFlag, setReApplyFlag] = useState(false);
  const [reApplyObj, setReApplyObj] = useState({});

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      role: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  useEffect(() => {
    const isAdmin = state?.isAdmin === "Y";
    setDataList(data);
    if (batchAction === "") {
      setSelectValue([]);
    }
    if (batchAction === "approve") {
      if (batchApproveStatus === "RTA") {
        // 退回批次簽核：僅保留退回且可由申請人重送之項目
        setDataList(data.filter((item) => item?.status === "RTA" && (item?.applyAdmin ?? false)));
      } else {
        // 暫存批次簽核：僅保留暫存
        setDataList(data.filter((item) => item?.status === "D"));
      }
      return;
    }
    if (approveFlag && batchAction === "delete" && !isAdmin) {
      setDataList(data.filter((item) => item.status === "D"));
    } else {
      setDataList(data);
    }
  }, [data, batchAction, batchApproveStatus, approveFlag, state?.isAdmin]);

  const orderNoTemplate = (data, props) => {
    return <span>{props.rowIndex + 1}</span>;
  };

  const actionBodyTemplate = (rowData) => {
    const lockStatus = ["P", "C"];
    const isAdmin = state?.isAdmin === "Y" && isCompany && rowData?.status === "C";
    const isDraft = rowData?.status === "D";
    const isPending = rowData?.status === "P";
    const isRTA = rowData?.status === "RTA";

    const canApproveAction = isPending && (rowData?.canApprove ?? false);
    const canRTAEdit = isRTA && (rowData?.applyAdmin ?? false);
    const canRTAView = isRTA && !(rowData?.applyAdmin ?? false);
    const canEdit = !approveFlag || isDraft || canRTAEdit || isAdmin;
    const canApprove = approveFlag && (canApproveAction || canRTAEdit);
    const canView = approveFlag && lockStatus.includes(rowData?.status);
    const canSetting = approveFlag && isDraft && isCompany;
    const canAuditLog = approveFlag && (lockStatus.includes(rowData?.status) || isRTA);
    const canClear = (!approveFlag || isDraft || canRTAEdit || isAdmin) && rowData?.dataList?.length > 0;

    return (
      <div className="flex gap-1 items-center justify-center">
        {/* 查看 */}
        {canView && (
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={canApprove ? t("button.approve") : t("button.detail")}
            tooltipOptions={{ position: "top" }}
            onClick={() => goItemPage(rowData, canApprove ? "approve" : "detail")}
            style={{ width: "2rem", height: "2rem" }}
          >
            {canApprove ? <FontAwesomeIcon icon="fa-solid fa-stamp" /> : <FontAwesomeIcon icon="fa-solid fa-eye" />}
          </Button>
        )}

        {/* 設定流程 */}
        {canSetting && (
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={t("button.approveSetting")}
            tooltipOptions={{ position: "top" }}
            disabled={approverList?.length === 0}
            onClick={() => {
              setRowData(rowData);
              setApproveFlowDialog(true);
            }}
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-users-gear" />
          </Button>
        )}

        {/* 編輯 */}
        {canEdit && (
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={t("register")}
            tooltipOptions={{ position: "top" }}
            onClick={() => goItemPage(rowData)}
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-edit" />
          </Button>
        )}

        {/* 重新申請 */}
        {canRTAEdit && (
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={t("button.reApply")}
            tooltipOptions={{ position: "top" }}
            onClick={() => {
              setReApplyFlag(true);
              setReApplyObj(rowData);
            }}
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-paper-plane" />
          </Button>
        )}

        {/* 清除數據 */}
        {canClear && (
          <Button
            icon="pi pi-eraser"
            rounded
            text
            severity="danger"
            className="p-button-icon-only"
            tooltip={t("button.deleteData")}
            tooltipOptions={{ position: "top" }}
            disabled={!isEditable}
            onClick={() => clearItemData(rowData)}
            style={{ width: "2rem", height: "2rem" }}
          />
        )}

        {/* 流程紀錄 */}
        {canAuditLog && (
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={t("button.approveFlow")}
            tooltipOptions={{ position: "top" }}
            onClick={() => {
              axios_queryApproveHistory({ identifySeq: rowData?.identifySeq });
              setApproveHistoryDialog(true);
            }}
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-people-line" />
          </Button>
        )}
      </div>
    );
  };

  const statusBodyTemplate = (data) => {
    return (
      <Tag
        severity={data?.dataList?.length > 0 ? "success" : "warning"}
        value={data?.dataList?.length > 0 ? t("registered") : t("no_registered")}
      ></Tag>
    );
  };

  const approveStatusBodyTemplate = (status) => {
    const colorMap = {
      D: "var(--gray-400)",
      C: "var(--green-700)",
      P: "var(--yellow-300)",
      RTA: "var(--red-600)",
    };
    const textColorMap = {
      P: "var(--yellow-800)",
    };

    if (status) {
      return (
        <span
          className={`p-tag`}
          style={{
            background: colorMap[status] || "var(--gray-300)",
            color: textColorMap[status] || "#fff",
          }}
        >
          {t(`approve.${status}`)}
        </span>
      );
    }
  };

  const goItemPage = (data, action) => {
    let classNoInfoData = {
      className: classNoInfo?.className,
      classNo: data?.classNo,
      classSeq: classNoInfo?.classSeq,
      displayClassName: classNoInfo?.displayClassName,
      displayClassNo: classNoInfo?.displayClassNo,
    };
    setItemObj((pre) => {
      return {
        ...pre,
        data,
        classNoInfoData,
        places: places, // V0.75 場所資訊
      };
    });
    setAction(action ?? (data?.dataList?.length > 0 ? "update" : "create"));
    navigate(data?.dataList?.length > 0 ? "detailUpdate" : "detailCreate");
    // setCurrentStatus({
    //     role: getValues("role"),
    //     status: getValues("status")
    // })
  };

  const clearItemData = (data) => {
    let classNoInfoData = {
      className: classNoInfo?.className,
      classNo: data?.classNo,
      classSeq: classNoInfo?.classSeq,
      displayClassName: classNoInfo?.displayClassName,
      displayClassNo: classNoInfo?.displayClassNo,
    };
    setItemObj((pre) => {
      return {
        ...pre,
        data,
        classNoInfoData,
        places: places, // V0.75 場所資訊
      };
    });
    setDelDialog(true);
  };

  // 審核紀錄查詢
  const axios_queryApproveHistory = (reqBody) => {
    checkLoading(loading);
    queryApproveHistory(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          setApproveHistoryList(res.data.RespBody.logList);
          setApproveHistoryFlowList(res.data.RespBody.flowList);
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  const oppositeTemplate = (item) => {
    const colorMap = {
      A: "var(--green-700)",
      C: "var(--green-700)",
      RTA: "var(--red-600)",
    };
    return (
      <span className="p-tag text-sm" style={{ background: colorMap[item?.action] || "var(--gray-300)" }}>
        {t("approveAction." + item?.action)}
      </span>
    );
  };

  const contentTemplate = (item) => {
    return (
      <div className="flex flex-column gap-1">
        <span className="font-bold">{item?.userName}</span>
        <small className="text-color-secondary">{item?.createDateTime}</small>
        {item?.memo && <small>{item?.memo}</small>}
      </div>
    );
  };

  const flowOppositeTemplate = (group) => {
    const firstUser = group?.[0];
    const count = group?.length ?? 0;
    // 同關卡共用 model，取第一筆即可；申請人關卡（sort 0）無 model 則不顯示
    const model = firstUser?.model;

    const tooltipId = `tt-${firstUser?.userSeq || Math.random()}`;

    return (
      <div className="flex-auto">
        {model && <div className="text-xs text-color-secondary mb-1">{t(`approveModelOption.${model}`)}</div>}
        <Avatar
          label={firstUser?.userName?.[0] ?? "U"}
          shape="circle"
          className={`p-overlay-badge tooltip-${tooltipId}`}
          data-pr-tooltip={group
            .map(
              (u) =>
                `${u.userName}${u.action ? ` - ${t(`approveAction.${u.action}`)}` : ``}${
                  u.approveDateTime ? ` - ${u.approveDateTime}` : ``
                }`,
            )
            .join("\n")}
        >
          {count > 1 && <Badge value={count} severity="danger" />}
        </Avatar>
        <Tooltip target={`.tooltip-${tooltipId}`} />
      </div>
    );
  };

  const flowMarkerTemplate = (group) => {
    const hasReject = group.some((item) => item.isPass === "N");

    if (!hasReject) {
      return (
        <span
          className="flex w-2rem h-2rem align-items-center justify-content-center border-circle z-1 shadow-1"
          style={{ color: "var(--primary-color)" }}
        >
          <FontAwesomeIcon icon="fa-solid fa-circle-check" />
        </span>
      );
    } else {
      return (
        <span className="flex w-2rem h-2rem align-items-center justify-content-center border-circle z-1 shadow-1"></span>
      );
    }
  };

  const textEllipsis = (rowData, props) => {
    const uid = `${[props.field]}-${rowData?.identifySeq}`;
    return (
      <span id={uid} className="text-ellipsis">
        {rowData?.[props.field]}
        <Tooltip target={`#${uid}`} content={rowData?.[props.field]} position="bottom" mouseTrack />
      </span>
    );
  };

  const axios_reApplyWork = () => {
    checkLoading(loading);
    approveWork({
      identifySeq: reApplyObj?.identifySeq,
      action: "C",
      memo: getValues("memo"),
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.reApply") + " " + t("message.success"));
          setReApplyFlag(false);
          setReApplyObj({});
          setValue("memo", "");
          if(reQuery){
            reQuery();
          }
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  return (
    <>
      <PrimePanel header={`${header}  (${dataList?.length})`} toggleable className="dataTable-panel">
        <DataTable
          stripedRows
          className="white-data-table hover-highlight no-shadow last-row-no-border"
          emptyMessage={t("no_rec")}
          value={dataList}
          scrollable
          scrollHeight="35rem"
          resizableColumns
          {...(dataList?.length > 20 && { virtualScrollerOptions: { itemSize: 73 } })}
          {...((batchAction === "delete" || batchAction === "approve") && {
            selectionMode: "checkbox",
            selection: selectValue,
            ...(batchAction === "approve" && {
              isDataSelectable: (e) =>
                batchApproveStatus === "RTA"
                  ? e?.data?.status === "RTA" && (e?.data?.applyAdmin ?? false)
                  : e?.data?.status === "D",
            }),
            onSelectionChange: (e) => {
              setSelectValue(e.value);
              dataDel?.(e.value);
            },
          })}
          {...((batchAction === "delete" || batchAction === "approve") &&
            selectValue.length > 0 && {
              footer: (
                <div className="text-right">
                  <span>{t("selectedCount", { count: selectValue.length })}</span>
                </div>
              ),
            })}
        >
          {(batchAction === "delete" || batchAction === "approve") && (
            <Column
              frozen
              selectionMode="multiple"
              style={{ width: "80px" }}
              bodyStyle={{ maxWidth: "80px" }}
              {...(batchAction === "approve" && {
                showSelectionElement: (rowData) =>
                  batchApproveStatus === "RTA"
                    ? rowData?.status === "RTA" && (rowData?.applyAdmin ?? false)
                    : rowData?.status === "D",
              })}
            />
          )}
          {approveFlag && (
            <Column
              frozen
              field="status"
              style={{ width: "80px" }}
              bodyStyle={{ maxWidth: "80px" }}
              body={(rowData) => approveStatusBodyTemplate(rowData?.status)}
            />
          )}
          <Column
            frozen
            header={t("itemNo")}
            body={orderNoTemplate}
            style={{ width: "80px" }}
            bodyStyle={{ maxWidth: "80px" }}
          />
          <Column
            field="placeName"
            header={t("place")}
            style={{ width: "100px" }}
            bodyStyle={{ maxWidth: "100px" }}
            body={textEllipsis}
          />
          <Column
            field="typeName"
            header={t("emission_pattern")}
            style={{ width: "180px" }}
            bodyStyle={{ maxWidth: "180px" }}
            body={textEllipsis}
          />
          <Column
            field="deviceName"
            header={t("equipment")}
            style={{ width: "150px" }}
            bodyStyle={{ maxWidth: "150px" }}
            body={textEllipsis}
          />
          <Column
            field="sourceName"
            header={t("emission_source")}
            style={{ width: "150px" }}
            bodyStyle={{ maxWidth: "150px" }}
            body={textEllipsis}
          />
          <Column
            field="remark"
            header={t("remark")}
            style={{ width: "150px" }}
            bodyStyle={{ maxWidth: "150px" }}
            body={textEllipsis}
          />
          <Column
            style={{ width: "100px" }}
            bodyStyle={{ maxWidth: "100px" }}
            field="displayStatus"
            header={t("status")}
            body={statusBodyTemplate}
          />
          {batchAction === "" && (
            <Column
              frozen
              alignFrozen="right"
              header={t("action")}
              body={actionBodyTemplate}
              style={{ width: "180px" }}
              bodyStyle={{ maxWidth: "180px" }}
            />
          )}
        </DataTable>
      </PrimePanel>

      {/* 簽核流程設定 */}
      <PrimeDialog
        visible={approveFlowDialog}
        onClose={() => {
          setApproveFlowDialog(false);
          setRowData("");
          setApproveFlowList([]);
          setApproveHistoryFlowList([]);
        }}
        onConfirm={() => {
          handleSettingApproveWorkFlow(
            {
              approveFlowList: approveFlowList,
              identifySeqList: [rowData?.identifySeq],
            },
            () => {
              setApproveFlowDialog(false);
              setRowData("");
              setApproveFlowList([]);
              setApproveHistoryFlowList([]);
            },
          );
        }}
        title={t("button.approveSetting")}
        bodyTemplate={
          <div className="w-full">
            <label className="form-label">{t("approverWorkFlow")}</label>
            <Dropdown
              optionLabel="label"
              optionValue="workFlowList"
              value={approveFlowList}
              options={approverList}
              placeholder={t("plz_chs")}
              className={`w-full`}
              onChange={(e) => {
                setApproveFlowList(e.value);
              }}
            />
            {rowData?.dataList?.length === 0 && <div className="text-red-500 font-bold pt-2">{t("approvedHint")}</div>}

            {approveFlowList?.length > 0 && (
              <div className="p-card bg-gray mt-2">
                <div className="p-card-body">
                  <div className="flex justify-content-center">
                    {approveFlowList.map((group, index) => {
                      const useList = group?.userList;
                      const firstUser = useList?.[0];
                      const count = useList?.length ?? 0;

                      const tooltipId = `tt-${index}`;
                      const isLast = index === approveFlowList.length - 1;
                      return (
                        <div key={index} className="flex align-items-center">
                          <div className="flex flex-column align-items-center">
                            <Avatar
                              label={firstUser?.userName?.[0] ?? "U"}
                              shape="circle"
                              className={`p-overlay-badge tooltip-${tooltipId}`}
                              data-pr-position="bottom"
                              data-pr-tooltip={`${
                                group?.model ? t(`approveModelOption.${group?.model}`) : ""
                              }\n${useList.map((u) => u.userName).join("\n")}`}
                            >
                              {count > 1 && <Badge value={count} severity="danger" />}
                            </Avatar>

                            <Tooltip target={`.tooltip-${tooltipId}`} />
                          </div>

                          {/* 👉 connector line */}
                          {!isLast && (
                            <div className="flex align-items-center px-3">
                              <div className="w-4rem border-top-2 border-gray-300" />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        }
      />

      {/* 簽核歷史紀錄 */}
      <PrimeDialog
        visible={approveHistoryDialog}
        onClose={() => {
          setApproveHistoryDialog(false);
          setApproveHistoryList([]);
        }}
        isShowConfBtn={false}
        title={t("button.approveFlow")}
        bodyTemplate={
          <div className="grid gap-2">
            <div className="col-12">
              <div className="p-card bg-gray">
                <div className="p-card-body">
                  <Timeline
                    value={approveHistoryFlowList}
                    layout="horizontal"
                    align="top"
                    opposite={flowOppositeTemplate}
                    marker={flowMarkerTemplate}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <PrimePanel toggleable collapsed header={t("button.approveHistory")}>
                <Timeline value={approveHistoryList} opposite={oppositeTemplate} content={contentTemplate} />
              </PrimePanel>
            </div>
          </div>
        }
      />

      {/* 重新申請 */}
      <PrimeDialog
        visible={reApplyFlag}
        onClose={() => {
          setReApplyFlag(false);
          setReApplyObj({});
          setValue("memo", "");
        }}
        onConfirm={axios_reApplyWork}
        title={t("button.reApply")}
        bodyTemplate={
          <div className="grid gap-2">
            <div className="col-12">
              <FormTextarea
                register={register}
                errors={errors}
                id="memo"
                name="memo"
                type="text"
                labelText={t("approveMemo")}
                areaClass="w-full"
                disabled={!isEditable}
              />
            </div>
          </div>
        }
      />
    </>
  );
};

export default ActivityTable;
